import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseDataGlance from './baseGlances/baseDataGlance'



export default function Payments(props) {

    const { t } = useTranslation();
    return (
        <>
            <BaseDataGlance cssContentClass='payments-glance-body'
                cssHeadingClass='payments-glance-heading'
                cssIconClass='icons8-bank-cards-filled'
                Heading={t('Payments')}
                DataPoint1={props.DP1}
                DataPoint3={props.DP2 + ' ' + t('Transactions')}
                showForwardButton={true}
            ></BaseDataGlance>
        </>
    );
}